<script setup lang="ts">
import BaseTabs from '@/common/components/molecules/baseTabs/BaseTabs.vue';
import { setup } from './navigationSubHeader.setup';

const { tabs, activeValue, isVisible, onSelectTab } = setup();
</script>

<template>
  <base-tabs
    v-if="isVisible"
    class="navigation-sub-header"
    :tabs="tabs"
    :model-value="activeValue"
    @update:model-value="onSelectTab"
  />
</template>

<style scoped lang="scss">
// 화면 이동 시 콘텐츠 로딩 마스크가 sub-header를 덮지 않도록 헤더 레이어 유지(BaseTabs 루트가 position:relative).
// 배경이 투명하면 z-index로 위에 떠 있어도 뒤의 로딩 마스크(다크 오버레이)가 비쳐 색이 죽으므로, base-header와 동일하게 불투명 배경을 준다.
.navigation-sub-header {
  z-index: $on-app-header;
  flex-shrink: 0;
  width: 100%;
  background-color: var(--app-header-bg-color);
}
</style>
